import { PlanDetail } from "./plan-detail.model";
import { Customer } from "./customer-details.model";
import { MemberDetail } from "./member-detail.model";
import { Questions } from "./question-details.model";
import { CoverDetails } from './cover-details';

export class QuotationDetails {

  public id: number;
  public itrNo: number;
  public actionFlag: string;
  public custCode: string;
  public custName: string;
  public category: string;
  public prodCode: string;
  public prodName: string;
  public quoteNo: string;
  public proposalNo: string;
  public itrFlag: string;
  public issueDate: Date;
  public fmDate: Date;
  public toDate: Date;
  public premBasis: string;
  public srcBuss: string;
  public srcName: string;
  public brokerCode: string;
  public phoneNo: string;
  public status: string;
  public statusDesc: string;
  public frzStatus: string;
  public convStatus: string;
  public totalAmount: number;
  public premium: string;
  public discPercent: number;
  public discAmount: number;
  public rateStatus: string;
  public fscAmount: number;
  public loadAmount: number;
  public mop: string;
  public channel: string;
  public stdCase: string;
  public propFromDate: string;
  public propToDate: string;

  public additional: any
  public notes: string
  // Customer Detail
  public customer: Customer;
  // Plan Detail
  public plan: PlanDetail[];

  public cover: CoverDetails[];
  // Member Detail
  public member: MemberDetail[];

  public question: Questions[];
}